export const ROUTE_NAMESPACE = process.env.CI_PROJECT_NAMESPACE?.split('/').join('-') || 'web-fos';
export const ENV = process.env.ENV || 'LOCAL';
